import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle, Gauge, Calendar, Fuel } from "lucide-react";
import { bikeImage, formatINR, formatKm } from "@/api";
import { waLink } from "@/config";

export const BikeCard = ({ bike, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, delay: (index % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ y: -6 }}
    className="group border border-white/10 bg-card overflow-hidden"
    data-testid={`bike-card-${bike.id}`}
  >
    <Link to={`/bike/${bike.id}`} data-testid={`bike-card-link-${bike.id}`} className="block relative overflow-hidden aspect-[4/3] bg-[#0a0a0a]">
      <img
        src={bikeImage(bike.image)}
        alt={bike.title}
        className="w-full h-full object-contain transition-transform duration-700 ease-out"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
      {bike.status === "sold" && (
        <span className="absolute top-4 left-4 bg-destructive text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5" data-testid={`bike-sold-badge-${bike.id}`}>
          Sold
        </span>
      )}
      {bike.featured && bike.status !== "sold" && (
        <span className="absolute top-4 left-4 bg-volt text-black text-xs font-bold uppercase tracking-widest px-3 py-1.5" data-testid={`bike-featured-badge-${bike.id}`}>
          Featured
        </span>
      )}
      <span className="absolute bottom-4 right-4 bg-black/70 backdrop-blur-md text-volt font-display font-semibold text-xl px-4 py-1.5 border border-volt/30" data-testid={`bike-price-${bike.id}`}>
        {formatINR(bike.price)}
      </span>
    </Link>
    <div className="p-5">
      <p className="text-[11px] uppercase tracking-[0.2em] text-volt mb-1">{bike.brand} · {bike.category}</p>
      <h3 className="font-display font-semibold text-xl tracking-tight text-white leading-tight" data-testid={`bike-title-${bike.id}`}>
        {bike.title}
      </h3>
      <div className="flex items-center gap-4 mt-3 text-xs text-white/50">
        <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-volt/70" />{bike.year}</span>
        <span className="flex items-center gap-1.5"><Gauge className="w-3.5 h-3.5 text-volt/70" />{formatKm(bike.km)}</span>
        <span className="flex items-center gap-1.5"><Fuel className="w-3.5 h-3.5 text-volt/70" />{bike.fuel}</span>
      </div>
      <div className="flex gap-3 mt-5">
        <Link
          to={`/bike/${bike.id}`}
          data-testid={`bike-view-button-${bike.id}`}
          className="flex-1 text-center text-sm font-semibold uppercase tracking-wider border border-white/20 text-white py-2.5 hover:border-volt hover:text-volt transition-colors duration-300"
        >
          View
        </Link>
        <a
          href={waLink(`Hi Deal 2 Wheel! I'm interested in the ${bike.title} (${bike.year}) listed at ${formatINR(bike.price)}.`)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`bike-whatsapp-button-${bike.id}`}
          className="flex-1 inline-flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wider bg-volt text-black py-2.5 hover:brightness-110 transition-[filter] duration-300"
        >
          <MessageCircle className="w-4 h-4" /> Enquire
        </a>
      </div>
    </div>
  </motion.div>
);

export default BikeCard;
